import * as React from 'react'
import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { trackUserAddRemoveRecipe } from 'actions/loggingmanager'
import type { RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getRecipeCoreIdByIdMap } from 'selectors/menu-recipes/getRecipeCoreIdByIdMap'

import { type AddRecipeInfo, useAddValidRecipeToBasket } from './useAddValidRecipeToBasket'

export type AddRecipeFn = ReturnType<typeof useAddRecipe>
export const useAddRecipe = () => {
  const addValidRecipeToBasket = useAddValidRecipeToBasket()
  const dispatch = useDispatch()

  return React.useCallback(
    (
      coreRecipeId: RecipeCoreId,
      view?: string,
      recipeInfo?: AddRecipeInfo,
      orderId?: string,
      isOrderRecipe?: boolean,
    ) => {
      addValidRecipeToBasket(coreRecipeId, view, recipeInfo, orderId, isOrderRecipe)
      dispatch(trackUserAddRemoveRecipe())
    },
    [dispatch, addValidRecipeToBasket],
  )
}

export type AddRecipeByUuidFn = ReturnType<typeof useAddRecipeByUuid>
export const useAddRecipeByUuid = () => {
  const recipeCoreIdByIdMap = useSelector(getRecipeCoreIdByIdMap)
  const addRecipe = useAddRecipe()

  return useCallback(
    (
      recipeId: RecipeUUID,
      view?: string,
      recipeInfo?: AddRecipeInfo,
      orderId?: string,
      isOrderRecipe?: boolean,
    ) => {
      const coreId = recipeCoreIdByIdMap[recipeId]
      if (!coreId) {
        return false
      }

      addRecipe(coreId, view, recipeInfo, orderId, isOrderRecipe)

      return true
    },
    [recipeCoreIdByIdMap, addRecipe],
  )
}
